import { handleActions } from 'redux-actions'

import { initialState, RequirementState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils'

const actionsNames = ['getListOfRequirements', 'storeListOfRequirements']

interface Actions {
  getListOfRequirements: any
  storeListOfRequirements: any
}

export const actions: Actions = prepareActions(actionsNames, 'requirement') as Actions

export default handleActions<RequirementState, Payload>(
  {
    [actions.storeListOfRequirements]: (state, { payload }: any): RequirementState =>
      state
        .set('displayAgreements', payload.displayAgreements)
        .set('displayIdentityCheck', payload.displayIdentityCheck)
        .set('displayIncomeCheck', payload.displayIncomeCheck)
        .set('displayPaymentCheck', payload.displayPaymentCheck)
        .set('displayPollingWarning', payload.displayPollingWarning)
        .set('nextUrl', payload.nextUrl),
  },
  initialState
)
